import { InteractionHandler } from "../../Interactions";
import { SliderInteractionBehavior } from "./SliderInteractionBehavior";
import { mapLinear, clamp } from "flavr-common";
import { SliderReleaseMessage, SliderValueChangeMessage } from "../../../../messages/interaction/SliderInteractionMessages";
import { Vector3, Quaternion } from "flavr-math";
const tmpRayDirection = new Vector3();
const tmpRayOrigin = new Vector3();
const tmpQuaternion = new Quaternion();
export class SliderInteractionHandler extends InteractionHandler {
    constructor(interactionModule) {
        super(SliderInteractionBehavior.typestatic, [SliderInteractionBehavior.typestatic], [], []);
        this.interactionModule = interactionModule;
        this.grabbedModels = new Map();
    }
    getBehaviorDescription() {
        return "Wert Ändern";
    }
    onSelectButtonPress(params, uid, controller) {
        if (!SliderInteractionBehavior.is(params))
            return;
        const transform = this.interactionModule.getModelTransformation(uid);
        if (!transform)
            return;
        this.interactionModule.lockSelection(controller.uid, true);
        this.grabbedModels.set(controller.uid, uid);
        this.updateSliderValue(params.sliderUID, transform, controller);
    }
    onSelectButtonRelease(params, _uid, controller) {
        if (!SliderInteractionBehavior.is(params))
            return;
        this.grabbedModels.delete(controller.uid);
        this.interactionModule.lockSelection(controller.uid, false);
        this.connection.send(new SliderReleaseMessage(params.sliderUID));
    }
    onControllerMove(params, uid, controller) {
        if (!SliderInteractionBehavior.is(params))
            return;
        const grabbedModel = this.grabbedModels.get(controller.uid);
        if (!grabbedModel || grabbedModel !== uid)
            return;
        const transform = this.interactionModule.getModelTransformation(uid);
        if (!transform)
            return;
        this.updateSliderValue(params.sliderUID, transform, controller);
    }
    updateSliderValue(sliderUID, transform, controller) {
        const inverseRotation = tmpQuaternion.copy(transform.ori).invert();
        const rayDir = tmpRayDirection.set(0, 0, -1).applyQuaternion(controller.orientation).applyQuaternion(inverseRotation);
        const rayOrigin = tmpRayOrigin.subVectors(controller.position, transform.pos).applyQuaternion(inverseRotation);
        const hitPoint = rayOrigin.addScaledVector(rayDir, -rayOrigin.z / rayDir.z);
        const value = mapLinear(hitPoint.x, -0.5 * transform.scale.x, +0.5 * transform.scale.x, 0, 1);
        this.connection.send(new SliderValueChangeMessage(sliderUID, clamp(value, 0, 1)));
    }
}
